import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';

import { JwlTable } from '../../../../components';

import PieceModelCreateDialog from '../PieceModelCreateDialog';
import { GQLParty, GQLPieceModel } from '@jewelutions/core-crm-server-api-client-domain';
import { PlatformNavigation } from '../../navigation/PlatformNavigation';
import { successNotification } from '../../../../core/utils';
import { toast } from 'react-toastify';

interface IProps {
  party: GQLParty;
  pieceId: string;
  models: GQLPieceModel[];
}

const PieceModelsList: React.FC<IProps> = ({ party, pieceId, models }: IProps) => {
  const history = useHistory();
  const [data, setData] = useState([] as any[]);
  const [isCreatePieceModelDialogOpen, setIsCreatePieceModelDialogOpen] = useState(false);

  useEffect(() => {
    const mappedValues = models.map(model => {
      const materials: string[] = Array.from(
        new Set<string>(
          model.availableConfigurations.map((avConf: any) => {
            return avConf.materialType;
          })
        )
      );
      const availability = materials
        .map((material: string) => {
          return `${material} (${model.availableConfigurations
            .filter((avConf: any) => avConf.materialType === material)
            .map((avConf: any) => avConf.platingType)
            .join()})`;
        })
        .join(';');
      return {
        ...model,
        isPublishable: model.isPublishable ? 'YES' : 'NO',
        image: `3/3`,
        availability
      };
    });

    setData(mappedValues);
  }, [models]);

  let isAddButtonDisabled = false;
  const sizes = data.map(a => Array.from(new Set(a.availableConfigurations.map((b: any) => b.sizeType))));
  if (sizes.length > 0) {
    const diffSizes = Array.from(new Set(sizes.map(a => a[0])));
    isAddButtonDisabled = 2 * diffSizes.length >= 6;
  }

  const navigateToPieceModelDetails = (pieceModelId: string) => {
    history.push(
      PlatformNavigation.pieceModelDetails.pathFromParams({ pieceId: pieceId, pieceModelId: pieceModelId })
    );
  };

  const getPieceModelsRows = () => {
    return (
      data &&
      data.map((pieceModel: any) => {
        return {
          id: pieceModel.id,
          cells: [
            pieceModel.sizeType,
            pieceModel.stonesPlacementType,
            pieceModel.isPublishable,
            pieceModel.availability
          ]
        };
      })
    );
  };

  return (
    <Fragment>
      <JwlTable
        title="Piece Models Table"
        description="If you have been reading the overrides documentation page but you are, add more metadata..."
        columns={['Size', 'Stones', 'Publishable', 'Availability']}
        rows={getPieceModelsRows()}
        onTableRowClick={navigateToPieceModelDetails}
        children={
          <div>
            <Button
              variant="contained"
              color="primary"
              disabled={isAddButtonDisabled}
              onClick={() => {
                setIsCreatePieceModelDialogOpen(true);
              }}
            >
              <AddIcon />
              Add Piece Model
            </Button>
          </div>
        }
      />
      {isCreatePieceModelDialogOpen && (
        <PieceModelCreateDialog
          party={party}
          pieceId={pieceId}
          onClose={success => {
            if (success === true) {
              successNotification(toast, 'Piece model created successfully', () => {});
            }

            setIsCreatePieceModelDialogOpen(false);
          }}
        />
      )}
    </Fragment>
  );
};
export default PieceModelsList;
